import * as React from "react";
import PropTypes from "prop-types";
const SvgBadgesMulticolorProSmall = React.forwardRef(
  ({ color = "currentColor", size = 24, title, titleId, ...props }, ref) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      ref={ref}
      fill={color}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="none" fillRule="evenodd">
        <path
          d="M.844.999C.584.561.894 0 1.394 0h14.721a.32.32 0 01.275.159l7.021 11.842-7.021 11.842a.324.324 0 01-.275.159H1.395c-.502 0-.81-.561-.551-1L7.365 12z"
          fill="#fefefe"
        />
        <path
          d="M16.408 12L9.982 1.5h5.05c.234 0 .45.121.571.321L21.771 12zm-1.5 0H9.044L2.988 2.005a.332.332 0 01.284-.505h5.19z"
          fill="#fc4c02"
        />
        <path
          d="M14.908 12l-6.44 10.5H3.272a.333.333 0 01-.285-.506l6.057-9.995h5.863V12zm1.5 0h5.362l-6.168 10.178a.666.666 0 01-.57.321H9.99z"
          fill="#cf4017"
        />
      </g>
    </svg>
  )
);
SvgBadgesMulticolorProSmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgBadgesMulticolorProSmall;
